<section class="layout-wrapper landing section intro-section pb-0" id="hero">
    <div class="container">
        <div class="row justify-content-between align-items-center">

            <div class="css-1uccx33 e5x6z6z5">
                <div class="css-w2ft9l e1pzrm670">
                    <div class="row justify-content-center">
                        <div class="col-lg-8">
                            <div class="text-center">
                               
                              

                                <h1 class="mb-3 ff-secondary fw-semibold lh-base">{{'homepage.homeMaster.classRoomCommunity' |translate}}</h1>
                                <p class="text-muted">
                         
                                    <span style="font-weight: bold;color:darkgreen">{{ 'general.anatalebPlatform' | translate }}</span>
                                <span>:&nbsp;{{ 'homepage.homeMaster.classRoomCommunitySub1' | translate }}</span>
                                </p>
                                <p class="text-muted">
                                    {{ 'homepage.homeMaster.classRoomCommunitySub2' | translate }}
                                </p>
                            </div>
                        </div>
                        <!-- end col -->
                    </div>

                

                    <div *ngIf="!userData" class="css-193h5r6 e5x6z6z3">
                        <div class="css-1n7dkjo e3xwyfj2">
                          <h4>{{ 'general.getStartedAsA' | translate }}</h4>
                          <div class="css-1fbuti"></div>
                          <div class="button-container css-bf04xg e3xwyfj1">
                           
                          <button  (click)="openRoleModal('Teacher')" class="css-v0qt7e e2luh1f0">
                              <div style="width:72px;height:72px"
                                   class="gatsby-image-wrapper css-1qhcyp e1he4rkg0">
                                <picture>
                                  <source type="image/webp" srcset="/assets/images/dojo/teacher_badge.png 72w" sizes="72px">
                                  <img width="72" height="72" src="/assets/images/dojo/teacher_badge.png" alt="" style="object-fit: contain; opacity: 1;">
                                </picture>
                              </div>
                              {{ 'general.teacher' | translate }}
                              <div class="css-7e8qg8 e2luh1f1"></div>
                            </button>


                            <button  (click)="openRoleModal('Student')"  class="css-v0qt7e e2luh1f0">
                              <div data-gatsby-image-wrapper="" style="width:72px;height:72px"
                                   class="gatsby-image-wrapper css-1qhcyp e1he4rkg0">
                                <picture>
                                  <source type="image/webp" srcset="/assets/images/dojo/student_badge.webp 72w" sizes="72px">
                                  <img width="72" height="72" src="/assets/images/dojo/student_badge.png" alt="" style="object-fit: contain; opacity: 1;">
                                </picture>
                              </div>
                              {{ 'general.student' | translate }}
                              <div class="css-7e8qg8 e2luh1f1"></div>
                            </button>
<!-- 
                            <button  (click)="openRoleModal('Parent')" class="css-v0qt7e e2luh1f0">
                              <div data-gatsby-image-wrapper="" style="width:72px;height:72px"
                                   class="gatsby-image-wrapper css-1qhcyp e1he4rkg0">
                                <picture>
                                  <source type="image/webp" srcset="/assets/images/dojo/parent.svg 72w" sizes="72px">
                                  <img width="72" height="72" src="/assets/images/dojo/parent.svg" alt="" style="object-fit: contain; opacity: 1;">
                                </picture>
                              </div>
                              {{ 'general.parent' | translate }}
                              <div class="css-7e8qg8 e2luh1f1"></div>
                            </button> -->

                            <!-- <button  (click)="openRoleModal('InstitutionLeader')"  class="css-v0qt7e e2luh1f0">
                              <div data-gatsby-image-wrapper="" style="width:72px;height:72px"
                                   class="gatsby-image-wrapper css-1qhcyp e1he4rkg0">
                                <picture>
                                  <source type="image/webp" srcset="/assets/images/dojo/school_leader_badge.webp 72w" sizes="72px">
                                  <img width="72" height="72" src="/assets/images/dojo/school_leader_badge.png" alt="" style="object-fit: contain; opacity: 1;">
                                </picture>
                              </div>
                              {{ 'general.instituteManagement' | translate }}
                              <div class="css-7e8qg8 e2luh1f1"></div>
                            </button> -->
                          </div>
                        </div>
                      </div>
                      
                </div>
            </div>

        </div>
        <!-- end row -->
    </div>
    <!-- end container -->
</section>
<!-- Example usage in a parent component -->
<app-role-modal 
  [isModalOpen]="isModalVisible"
  [selectedRole]="selectedRole"
  [(emailAddress)]="userEmail"
  (close)="handleModalClose()"
  (continueEvent)="handleModalContinue($event)">
</app-role-modal>
